import React, { FC, useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import Icons from '../icons/Icons'
import Button from '../button/Button'

export const SortColumn: FC = ({setColumnOrder, table}) => {
  const columns = table
  .getVisibleLeafColumns()
  .filter(col => col.id !== 'select') // Exclude the first select
  .map(col => ({ id: col.id, prettyName: col.columnDef.prettyName }));

  const [thisColumn, setThisColumn] = useState(columns.map(cl => cl.id));

  useEffect(() => {
    const isEqual = columns.length === thisColumn.length
    if (!isEqual) {
      setThisColumn(columns.map(cl => cl.id))
    }
  }, [ columns ])
  
  // Update columnOrder whenever thisColumn changes
  useEffect(() => {
    const newCol = thisColumn.map((col) => col.valueOf())

    setColumnOrder(newCol)
  }, [ thisColumn ]);
  
  return (
    <div className="msync-manage-column-dnd">
      <ReactSortable tag="ol" role="list" className="msync-manage-column-dnd__list" list={thisColumn} setList={setThisColumn}>
           { columns.map((item, key) => (
              <li key={key} role="listitem" className="msync-button msync-button--is-style-link msync-button--is-theme-secondary msync-manage-column-dnd__list__item">
                  {item.prettyName}
                  <Icons type={'drag-dots'} />
              </li>
          ))}  
      </ReactSortable>
    </div>
  )
}